// removed by extract-text-webpack-plugin
module.exports = {"classAlsoConsider":"AlsoConsider-classAlsoConsider-0674dcfe"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/AlsoConsider.scss
// module id = 811
// module chunks = 0